import {useMemo} from 'react';

interface IPageBreakProps {
    before?: boolean;
}

const PageBreak = (props: IPageBreakProps) => {
    const {before = false} = props;

    const breakOptions = useMemo(() => {
        return before ? 'page-break-before' : 'page-break-after';
    }, [before]);

    return (
        <div className={breakOptions}/>
    );
};

export default PageBreak;
